export default __webpack_public_path__ + "static/media/222.1274f961.jpg";